module.exports = __webpack_public_path__ + "img/count.299641ff.png";